import { useLingui } from "@lingui/react"
import { Box, Button, Card, CardContent, CardHeader, Checkbox, Grid, IconButton, Modal, TextField, Typography } from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import { msg } from '@lingui/macro'
import { useState } from "react"
import httpReq from "../../../services/httpReq"
import HomeMadeSnackbar from "../../snackbars/HomeMadeSnackbar"
import { SketchPicker } from "react-color"
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'

const ModalAddTag = ({ isMobile, isModalAddOpen, setIsModalAddOpen }) => {
  const { control, formState, handleSubmit, getValues } = useForm({ mode: 'onChange' })
  const { _ } = useLingui()
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false)
  const [isMultiple, setIsMultiple] = useState(false)
  const [isDeletable, setIsDeletable] = useState(false)
  const [snackbarValues, setSnackbarValues] = useState({
    btnColor: '',
    color: '',
    closeAction: true,
    message: ''
  })


  const saveNewTag = async () => {
    const value = getValues()
    const data = {
      name: value.name,
      code: `TAG-${value.name}`,
      description: value.name,
      label: `${value.name[0]}-${value.name}`,
      isMultiple: isMultiple,
      isDeletable: isDeletable
    }
    const res = await httpReq('Tag/Insert', 'POST', data, true)
    if (!res || res.responseAnyError) return;
    if (!res.responseAnyError) {
      setSnackbarValues({
        btnColor: 'white',
        closeAction: true,
        message: `Tag ${res.responseData.name} added`,
        color: 'green'
      })
      setIsModalAddOpen(false)
      setIsOpenSnackbar(true)
    } else {
      setSnackbarValues({
        btnColor: 'white',
        closeAction: true,
        message: res.responseMessage,
        color: 'red'
      })
      setIsOpenSnackbar(true)
    }
  }


  return (
    <>
      <Modal sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={isModalAddOpen}>
        <Card sx={{ width:  '30vw',  height: '30vh' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2,
              py: 1.5,
            }}
          >

            <Typography variant="h6" sx={{ flex: 1 }}>
              {`Add tag`}
            </Typography>

            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Button sx={{ borderRadius: 10 }} variant="contained" disabled={!formState.isValid} onClick={() => saveNewTag()}>
                <SaveIcon color={!formState.isValid ? 'inherit' : 'white'} />
              </Button>
              <IconButton onClick={() => {
                setIsModalAddOpen(false)
              }
              }><CloseIcon color="error" /></IconButton>
            </Box>
          </Box>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Controller
                  name='name'
                  control={control}
                  defaultValue=""
                  render={({ field, fieldState }) => (
                    <TextField
                      margin={isMobile ? 'dense' : 'normal'}
                      fullWidth
                      required
                      label={_(msg`Tag Name`)}
                      autoComplete='name'
                      autoFocus
                      error={!!fieldState.error}
                      helperText={fieldState.error ? fieldState.error.message : null}
                      {...field}
                    />
                  )}
                  rules={{ required: _(msg`Tag Name is required`) }}
                />

              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 2 }}>
                <Box sx={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                  <Checkbox checked={isMultiple} onChange={e => {
                    setIsMultiple(e.target.checked)
                  }} />
                  <Typography>Is multiple?</Typography>
                </Box>
                <Box sx={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                  <Checkbox checked={isDeletable} onChange={e => {
                    setIsDeletable(e.target.checked)
                  }} />
                  <Typography>Is deletable?</Typography>
                </Box>

              </Grid>

            </Grid>
        
          </CardContent>
        </Card>
      </Modal>
      {isOpenSnackbar &&
        <HomeMadeSnackbar
          setIsOpen={setIsOpenSnackbar}
          btnColor={snackbarValues.btnColor}
          closeAction={snackbarValues.closeAction}
          color={snackbarValues.color}
          message={snackbarValues.message}
        />}
    </>
  )
}
export default ModalAddTag